import React, { useMemo } from 'react'
import type { SelectCreatableProps } from '@ztechapps/webui.input'
import { AddressSelectCreatable } from '@ztechapps/webui.location'
import type { UseVendorAddressProps } from '@ztechapps/purchase-order.common'
import { useVendorAddress } from '@ztechapps/purchase-order.common'
import isBoolean from 'lodash/isBoolean'

//endregion
export const VendorAddress = ({
  filter,
  limit,
  sort,
  showAll,
  ...rest
}: UseVendorAddressProps & SelectCreatableProps) => {
  const { list } = useVendorAddress({ filter, limit, sort })

  const options = useMemo(() => {
    if (isBoolean(showAll)) {
      if (showAll) return [...(list ?? []), { fullAddress: 'Show own addresses only.', showAll: false }]
      return [...(list ?? []), { fullAddress: 'Show addresses from other contacts within the company.', showAll: true }]
    }
    return list
  }, [list, showAll])

  return <AddressSelectCreatable options={options} {...rest} />
}
